"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEnter = exports.getWidth = void 0;

// Get client width
var getWidth = function getWidth(text) {
  var div = document.createElement('div');
  div.style.display = 'inline-block';
  div.innerHTML = text;
  document.body.appendChild(div);
  var width = div.clientWidth;
  document.body.removeChild(div);
  return width;
}; // Handle Enter-Key event


exports.getWidth = getWidth;

var handleEnter = function handleEnter(e, callback) {
  var key = e.key;

  if (key === 'Enter' && typeof callback === 'function') {
    callback(e);
  }
};

exports.handleEnter = handleEnter;
//# sourceMappingURL=dom.js.map